export const CODE_LINE_HEIGHT = 24;
export const LINE_HEIGHT_OFFSET = -12;
export const HOT_SPOT_OFFSET = -7;
